var map = {
	"./background_loging.png": "c465",
	"./background_person.png": "88b4",
	"./illustrations/posting_photo.svg": "3174",
	"./logo-conecta.svg": "12bd",
	"./logo-default.png": "c801",
	"./logo-iris-assistance.png": "d9b7",
	"./logo-iris-global.png": "38a7",
	"./logo-iris-global.svg": "9c37",
	"./logo.svg": "1ae4",
	"./purposes/cloud.png": "0289",
	"./purposes/mujer_up.png": "3beb",
	"./purposes/vote_bronze.png": "a835",
	"./purposes/vote_gold.png": "b9d8",
	"./purposes/vote_platinum.png": "261e",
	"./purposes/vote_silver.png": "e4a0",
	"./svg/error.svg": "cf30",
	"./svg/warning.svg": "c026",
	"./winners/hombre_contento.png": "b5b1",
	"./winners/prize_cup.gif": "23bd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";